<template>
  <div>
    <div class="main-banner-white">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="text-wrapper">
            <div class="h1 font-weight-bolder">
              <div class="pt-2">Supporta le aziende locali!</div>
            </div>
            <div class="h4">
              <div class="pt-1">Cerchiamo di facilitare il modo in cui le persone entrano in contatto con le aziende utilizzando la tecnologia.</div>
            </div>
            <b-button variant="dark" class="mt-2 text-white btn-style" to="/come-funziona">Come funziona</b-button>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="centered-image">
            <img src="../assets/img/cover-bg-2.png" alt="first illustration" />
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION 2 --->
    <div class="txt-color bg-green">
      <div class="container d-none d-sm-block">
        <div class="row pt-5 pb-5">
          <div class="col-8 text-left align-self-center">
            <div class="h1 font-weight-bolder">
              <div class="pt-2">Ti aiutiamo ad essere presente online.</div>
            </div>
            <div class="h4">
              <div class="pt-2">Leggi il nostro manifesto per saperne di più</div>
            </div>
            <b-button variant="success" class="mt-2 btn-style" to="/la-valle#sitoweb">Questo sitoweb</b-button>
          </div>
        </div>
      </div>
      <div class="container d-block d-sm-none">
        <div class="row pt-5 pb-5">
          <div class="col-12">
            <div class="h1 font-weight-bolder">
              <div class="pt-2">Ti aiutiamo ad essere presente online.</div>
            </div>
            <div class="h4">
              <div class="pt-2">Leggi il nostro manifesto per saperne di più</div>
            </div>
            <b-button variant="success " class="mt-2 btn-style" to="/la-valle#sitoweb">Questo sitoweb</b-button>
          </div>
        </div>
      </div>
    </div>

    <!-- SECTION 3 -->
    <div class="text-black bg-light">
      <div class="container d-none d-sm-block">
        <div class="row row pt-5 pb-5">
          <div class="col-md-4 col-sm-4 text-center addMarginBottom">
            <div class="icon-step">
              <img src="../assets/icon-product.png" height="50" alt="icon-product" />
            </div>
            <h4 class="icon-title">Aziende</h4>
            <div class="icon-box-content">
              Ogni azienda della valle sente il bisogno di
              raccontare la sua storia e le sue tradizioni.
            </div>
          </div>
          <div class="col-md-4 col-sm-4 text-center addMarginBottom">
            <div class="icon-step">
              <img src="../assets/icon-shop.png" height="50" alt="icon-shop" />
            </div>
            <h4 class="icon-title">Prodotti</h4>
            <div class="icon-box-content">Permette ai tuoi clienti di restare in contatto e conoscere i prodotti di stagione.</div>
          </div>
          <div class="col-md-4 col-sm-4 text-center addMarginBottom">
            <div class="icon-step">
              <img src="../assets/icon-mobile.png" height="50" alt="icon-mobile" />
            </div>
            <h4 class="icon-title">Mobile</h4>
            <div class="icon-box-content">Visita il sitoweb anche da dispositivi mobili e tablet, consulta in modo facile la mappa.</div>
          </div>
        </div>
      </div>
      <div class="container d-block d-sm-none">
        <div class="row">
          <div class="col-md-4 col-sm-4 text-center addMarginBottom">
            <div class="icon-step">
              <img src="../assets/icon-product.png" height="50" alt="icon-product" />
            </div>
            <h3 class="icon-title">Aziende</h3>
            <div class="icon-box-content">
              Ogni azienda della valle sente il bisogno di
              raccontare la sua storia e le sue tradizioni.
            </div>
          </div>
          <div class="col-md-4 col-sm-4 text-center addMarginBottom">
            <div class="icon-step">
              <img src="../assets/icon-product.png" height="50" alt="icon-product" />
            </div>
            <h3 class="icon-title">Prodotti</h3>
            <div class="icon-box-content">Permette ai tuoi clienti di restare in contatto e conoscere i prodotti di stagione.</div>
          </div>
          <div class="col-md-4 col-sm-4 text-center addMarginBottom">
            <div class="icon-step">
              <img src="../assets/icon-product.png" height="50" alt="icon-product" />
            </div>
            <h3 class="icon-title">Mobile</h3>
            <div class="icon-box-content">Visita il sitoweb anche da dispositivi mobili e tablet, consulta in modo facile la mappa.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="main-banner-accordion">
      <div class="row">
        <div class="col-lg-6 col-xs-12">
          <div class="text-wrapper">
            <div class="h1 font-weight-bolder">
              <div class="pt-2">Per restare vicini ai vostri clienti.</div>
            </div>
            <div class="h4">
              <div
                class="pt-1"
              >Un portale online per aiutarti con posizione, contatti e sponsorizzare prodotti offerti da attività, aziende, ristoranti e botteghe della Valle di Comino. Per essere sempre vicini ai clienti.</div>
            </div>
            <div class="col-md-12 col-xs-12">
              <img class="img-footer" src="../assets/img/material-design.png" alt="flowers" />
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xs-12">
          <div class="accordion md-accordion" id="accordion-seed" role="tablist" aria-multiselectable="true">
            <div class="card">
              <div class="card-header" role="tab" id="id1">
                <a v-b-toggle.collapse-1 variant="primary">
                  <h2 class="mb-0">
                    <span class="rotate-icon" />
                    <div class="card-header-left-margin">Perché</div>
                  </h2>
                </a>
              </div>
              <b-collapse id="collapse-1" class="mt-2">
                <b-card>
                  <div class="card-body p-0 m-0">
                    <h3 class="card-title">La Valle di Comino, una risorsa</h3>
                    <p>Ci siamo ingegnati per capire in che modo essere di supporto alle realtà locali, spesso poco digitalizzate, ma che rappresentano un'imperdibile ricchezza per il nostro territorio.</p>
                  </div>
                </b-card>
              </b-collapse>
            </div>
            <div class="card">
              <div class="card-header" role="tab" id="id2">
                <a v-b-toggle.collapse-2 variant="primary">
                  <h2 class="mb-0">
                    <span class="rotate-icon" />
                    <div class="card-header-left-margin">Come</div>
                  </h2>
                </a>
              </div>
              <b-collapse id="collapse-2" class="mt-2">
                <b-card>
                  <div class="card-body p-0 m-0">
                    <h3 class="card-title">Piattaforma online</h3>
                    <p>Una piattaforma completamente gratuita per aiutare i commercianti a proporre i propri prodotti e ai clienti a poter trovare l'attività che cercavano.</p>
                  </div>
                </b-card>
              </b-collapse>
            </div>
            <div class="card">
              <div class="card-header" role="tab" id="id3">
                <a v-b-toggle.collapse-3 variant="primary">
                  <h2 class="mb-0">
                    <span class="rotate-icon" />
                    <div class="card-header-left-margin">Ricerca</div>
                  </h2>
                </a>
              </div>
              <b-collapse id="collapse-3" class="mt-2">
                <b-card>
                  <div class="card-body p-0 m-0">
                    <h3 class="card-title">Cerchi un'azienda?</h3>
                    <p>Scopri le realtà già presenti sulla mappa della Valle di Comino e visualizza contatti e prodotti. Supporta le aziende locali ed il commercio di prossimità.</p>
                  </div>
                </b-card>
              </b-collapse>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- SECTION 4 -->
    <div class="bg-light">
      <div class="container d-none d-sm-block">
        <div class="row pt-5 pb-5">
          <div class="col-8 text-left align-self-center">
            <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
            <div class="row mt-4">
              <div class="col-4 mr-4">
                <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività</b-button>
              </div>
              <div class="col-6">
                <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container d-block d-sm-none">
        <div class="row pt-5 pb-5">
          <div class="col-12">
            <div class="h3">Vogliamo aiutare le aziende della nostra valle, noi ci crediamo. E tu?</div>
          </div>
          <div class="col-12">
            <div class="row mt-4">
              <div class="col-6">
                <b-button variant="success" class="btn-block btn-style" to="/mappa">Cerca un'attività</b-button>
              </div>
              <div class="col-6">
                <b-button variant="dark" class="text-white btn-style" to="/registrati">Registra la tua attività</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  mounted() {
    console.log(process.env.VUE_APP_ENV);
    console.log(process.env.VUE_APP_API_URL);
  }
};
</script>

<style scoped>
.big-t {
  font-size: 1.2em;
}

.icon-step {
}

.icon-title {
  font-size: 1.2em;
}

.icon-box-content {
}
</style>
